import React, { ReactNode } from 'react';
import { withTranslation } from 'react-i18next';
import { Box, Button, Modal, SxProps, Typography } from '@mui/material';

import { IConfirmModalView } from '../interfaces';

import { useStyles } from './styles';
import { useModalStyles } from '@core/myta/hooks/modalStyles';
import { CloseIcon } from '@icons';
import BasicButton from '@components/BasicButton';

const ConfirmModalAltView = ({
  title = '',
  message,
  open,
  onCancel,
  onConfirm,
  confirmButtonName,
  cancelButtonName,
  onCancelAltAction,
  hideCloseButton,
  children,
  sx,
}: IConfirmModalView) => {
  const modalClasses = useModalStyles();
  const classes = useStyles();

  return (
    <Modal open={open} hideBackdrop sx={sx?.root}>
      <Box
        component="div"
        sx={{
          ...modalClasses.container,
          ...classes.container,
        }}
      >
        {!hideCloseButton && (
          <CloseIcon sx={classes.close} onClick={onCancel} />
        )}
        {title ? <Typography sx={classes.title}>{title}</Typography> : null}
        <Typography sx={classes.message}>{message}</Typography>
        <Box
          component="div"
          sx={{ ...classes.actions, ...sx?.actions } as SxProps}
        >
          {children}
          {onCancel ? (
            <BasicButton
              onClick={onCancelAltAction || onCancel}
              compact
              sx={classes.secondaryButton}
            >
              {cancelButtonName || 'No'}
            </BasicButton>
          ) : null}
          {onConfirm ? (
            <BasicButton onClick={onConfirm} primary compact>
              {confirmButtonName || 'Yes'}
            </BasicButton>
          ) : null}
        </Box>
      </Box>
    </Modal>
  );
};

export default withTranslation()(ConfirmModalAltView);
